import { getShops } from "./shopsService";

function getPaginator(response) {
  return (
    response?.shops ??
    response?.data?.shops ??
    response?.data ??
    response
  );
}

function getRows(response) {
  const paginator =
    getPaginator(response);

  if (Array.isArray(paginator?.data)) {
    return paginator.data;
  }

  if (Array.isArray(paginator)) {
    return paginator;
  }

  return [];
}

export async function getAllAnalyticsShops(
  params = {},
) {
  const perPage = 100;

  const firstResponse =
    await getShops({
      ...params,
      page: 1,
      per_page: perPage,
    });

  const firstPaginator =
    getPaginator(firstResponse);

  const firstRows =
    getRows(firstResponse);

  const lastPage =
    Number(
      firstPaginator?.last_page ??
        1,
    );

  if (
    !Number.isFinite(lastPage) ||
    lastPage <= 1
  ) {
    return firstRows;
  }

  const requests = [];

  for (
    let page = 2;
    page <= lastPage;
    page++
  ) {
    requests.push(
      getShops({
        ...params,
        page,
        per_page: perPage,
      }),
    );
  }

  const responses =
    await Promise.all(requests);

  const remainingRows =
    responses.flatMap(
      (response) =>
        getRows(response),
    );

  const combined = [
    ...firstRows,
    ...remainingRows,
  ];

  return Array.from(
    new Map(
      combined.map((shop) => [
        shop.id,
        shop,
      ]),
    ).values(),
  );
}